// extracted by mini-css-extract-plugin
module.exports = {"container":"compliance_container__bMlRc","heading":"compliance_heading__bAcNG"};